import { SvgIcon, SvgIconProps } from "@mui/material";

export const ArrowsExpandIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      d="M4 8V4M4 4H8M4 4L9 9M20 8V4M20 4H16M20 4L15 9M4 16V20M4 20H8M4 20L9 15M20 20L15 15M20 20V16M20 20H16"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
